var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuDotsVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_14341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.87497C11.7081 4.87497 12.6875 3.8956 12.6875 2.68749C12.6875 1.47937 11.7081 0.5 10.5 0.5C9.29187 0.5 8.3125 1.47937 8.3125 2.68749C8.3125 3.8956 9.29187 4.87497 10.5 4.87497Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.1875C11.7081 13.1875 12.6875 12.2081 12.6875 11C12.6875 9.79187 11.7081 8.8125 10.5 8.8125C9.29187 8.8125 8.3125 9.79187 8.3125 11C8.3125 12.2081 9.29187 13.1875 10.5 13.1875Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.5C11.7081 21.5 12.6875 20.5206 12.6875 19.3125C12.6875 18.1044 11.7081 17.125 10.5 17.125C9.29187 17.125 8.3125 18.1044 8.3125 19.3125C8.3125 20.5206 9.29187 21.5 10.5 21.5Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_14341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDotsVertical);
export default __webpack_public_path__ + "static/media/menu-dots-vertical.289c7929242423a0199903e75fc0419c.svg";
export { ForwardRef as ReactComponent };